
import { serviceHost } from '../../common/const';
import ServiceRequest from '../../utils/service-request';

export const downloadFile = async (data) => {
    try {
        let response = await ServiceRequest('post', 'blob', serviceHost + '/kyc/address/downloadFile', data);
        return { response, err: null };
    }
    catch (err) {
        if (err) {
            return { response: null, err };
        }
    };
}